<template>
  <div class="bbp-question" @keydown.esc="closeForm" tabindex="0">
    <div class="bbp-question-header">
      <span class="bbp-question-header-select"
            @click.stop="openSelectSearchLanguage = !openSelectSearchLanguage"
      >
        <span class="bbp-question-header-select__title">{{languageBySelect}}</span>
        <i class="bbp-icon-arrow bbp-question-header-select__icon"
           :class="{'bbp-question-header-select__icon_active': openSelectSearchLanguage}"/>
        <transition name="bbp-bounce">
          <span v-if="openSelectSearchLanguage"
                @mouseleave="openSelectSearchLanguage = false"
                class="bbp-question-header-options"
          >
            <span class="bbp-question-header-options__item"
                  v-for="option in languageOptions"
                  @click="setLanguage(option)"
                  :key="option.id"
            >
              {{option.title}}
            </span>
          </span>
        </transition>
      </span>
      <i class="bbp-icon-cross bbp-question-header__close" @click="closeForm"/>
    </div>
    <VuePerfectScrollbar class="bbp-question-body" :settings="{ wheelPropagation: false }">
      <section>
        <div class="bbp-question-body__text" v-html="textKPI1"></div>
        <BBPTable v-bind="tableKPI1"/>
        <div class="bbp-question-body__text" v-html="textKPI12"></div>
        <BBPTable v-bind="tableKPI2"/>
        <div class="bbp-question-body__text" v-html="textKPI13"></div>
        <BBPTable v-bind="tableKPI3"/>
      </section>
      <section>
        <div class="bbp-question-body__text" v-html="textKPI2"></div>
        <BBPTable v-bind="tableKPI4"/>
      </section>
      <section>
        <div class="bbp-question-body__text" v-html="textKPI3"></div>
      </section>
      <section>
        <div class="bbp-question-body__text" v-html="textKPI4"></div>
      </section>
      <section>
        <div class="bbp-question-body__text" v-html="textKPI5"></div>
      </section>
      <section>
        <div class="bbp-question-body__text" v-html="textKPI6"></div>
      </section>
      <section>
        <div class="bbp-question-body__text" v-html="textKPI7"></div>
      </section>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import BBPTable from '@/components/Main/BBPTable/BBPTable'
import en from '@/constants/kpiInfo/en'
import ru from '@/constants/kpiInfo/ru'
import enLocales from '@/locales/en.json'
import ruLocales from '@/locales/ru.json'
import { get } from 'lodash'

export default {
  name: 'BBPQuestion',
  components: {VuePerfectScrollbar, BBPTable},
  computed: {
    instanceLanguage () {
      return this.locale === 'ru' ? ru : en
    },
    textKPI1 () {
      return this.instanceLanguage.textKPI1
    },
    textKPI12 () {
      return this.instanceLanguage.textKPI12
    },
    textKPI13 () {
      return this.instanceLanguage.textKPI13
    },
    textKPI2 () {
      return this.instanceLanguage.textKPI2
    },
    textKPI3 () {
      return this.instanceLanguage.textKPI3
    },
    textKPI4 () {
      return this.instanceLanguage.textKPI4
    },
    textKPI5 () {
      return this.instanceLanguage.textKPI5
    },
    textKPI6 () {
      return this.instanceLanguage.textKPI6
    },
    textKPI7 () {
      return this.instanceLanguage.textKPI7
    },
    tableKPI1 () {
      const rows = this.getTextByLocal('kpiInfo.table.rows')
      const columns = this.getColumn('kpiInfo.table.columns')
      return {rows, columns}
    },
    tableKPI2 () {
      const rows = this.getTextByLocal('kpiInfo.tableTwo.rows')
      const columns = this.getColumn('kpiInfo.tableTwo.columns')
      return {rows, columns}
    },
    tableKPI3 () {
      const rows = this.getTextByLocal('kpiInfo.tableThree.rows')
      const columns = this.getColumn('kpiInfo.tableThree.columns')
      return {rows, columns}
    },
    tableKPI4 () {
      const rows = this.getTextByLocal('kpiInfo.tableFour.rows')
      const columns = this.getColumn('kpiInfo.tableFour.columns')
      return {rows, columns}
    },
    locales () {
      return this.instanceLanguage === 'ru' ? ruLocales : enLocales
    }
  },
  data () {
    return {
      locale: 'en',
      openSelectSearchLanguage: false,
      languageBySelect: 'en',
      languageOptions: [
        {
          id: 'en',
          title: 'English'
        },
        {
          id: 'ru',
          title: 'Russian'
        }
      ]
    }
  },
  methods: {
    getTextByLocal (prop) {
      const val = get(this.locales, prop, 'prop')
      return val
    },
    closeForm () {
      this.$emit('close')
    },
    setLanguage (language) {
      this.languageBySelect = language.id
      this.locale = language.id
    },
    getColumn (text) {
      return this.getTextByLocal(`${text}`).map((item, index) => ({
        title: item,
        prop: index
      }))
    }
  }
}
</script>

<style lang="scss">
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bbp-question{
  @include global-font;
  display: grid;
  width: 100%;
  height: 100%;
  background: $color-white;
  border-radius: 8px;

  &-header {
    padding: 15px 18px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    &-select {
      position: absolute;
      display: flex;
      align-items: center;
      right: 50px;
      top: 15px;
      transition: 0.3s;
      cursor: pointer;
      color: $color-accent;

      &__icon {
        font-size: 8px;
        margin-left: 8px;
        transition: 0.3s;

        &_active {
          transform: rotate(180deg);
        }
      }

      &__title {
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        text-transform: capitalize;
        line-height: 19px;
      }

      &:hover {
        color: $color-accent-hover;
      }
    }

    &-options {
      position: absolute;
      top: 30px;
      width: 70px;
      right: 0;
      display: grid;
      grid-gap: 8px;
      box-shadow: 0 0 15px rgba($color-black, 0.08);
      border-radius: 4px;
      background-color: $color-white;
      padding: 16px 12px;
      z-index: 2;

      &__item {
        font-weight: 500;
        font-size: 13px;
        line-height: 16px;
        color: $color-black;
        transition: 0.3s;

        &:hover {
          color: $color-accent;
        }
      }
    }

    &__close {
      position: absolute;
      top: 11px;
      right: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $color-silver;
      width: 26px;
      height: 26px;
      transition: 0.3s;
      cursor: pointer;

      &:hover {
        color: $color-dusty-gray
      }
    }

    &__title {
      font-weight: 500;
      font-size: 17px;
      text-align: center;
    }
  }

  &-body {
    padding: 0 24px;
    max-width: 1000px;
    width: 100%;
    max-height: calc(100vh - 120px);
    overflow: hidden;

    &__title {
      font-weight: 500;
      font-size: 17px;
      line-height: 20px;
      text-align: center;
    }

    &__text {
      display: block;
      font-size: 14px;
      line-height: 120%;
      white-space: pre-line;

      h1 {
        font-weight: 500;
        font-size: 17px;
        line-height: 20px;
        text-align: center;
      }

      i {
        font-style: italic;
      }

      b {
        font-weight: bold;
      }

      h2 {
        font-weight: bold;
        text-align: center;
        font-size: 16px;
        line-height: 19px;
      }

      ul {
        list-style-type: none;
        counter-reset: item;

        li:before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 4px;
          margin-bottom: 2px;
          margin-right: 6px;
          background: black;
          border-radius: 50%;
        }
      }

      ol {
        list-style-type: none;
        counter-reset: item;

        li:before {
          content: counter(item) ') ';
          counter-increment: item;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPQuestion/BBPQuestion.vue